Ext.define('SA.view.BoxedSpinner', {
    alias: 'widget.boxed-spinner',
    extend: 'SA.view.SimpleContainer',

    backgroundColor: '#fff',
    baseCls: 'sa-boxed-spinner',
    size: 'large',

    sizeCfgs: {
        small: {padding: 4, width: 60},
        medium: {padding: 4, width: 84},
        large: {padding: 6, width: 108}
    },

    initComponent() {
        var {padding, width} = this.sizeCfgs[this.size],
            spinnerMaxLength = width - (padding * 2) - 2; 

        this.items = [{xtype: 'spinner', maxLength: spinnerMaxLength}];

        this.callParent();

        this.width = this.height = width;
        this.padding = padding;
        this.protoEl.setStyle({backgroundColor: this.backgroundColor});
    }
});